import { render, staticRenderFns } from "./closure-agreement.vue?vue&type=template&id=7195f90a"
import script from "./closure-agreement.vue?vue&type=script&lang=js"
export * from "./closure-agreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports